import CalculationField from "@/components/Calculator/Components/CalculationField/calculationField.component";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    setCalculationValue: (field: string, value: string) => void;
    cementscreedLength: number;
    cementscreedWidth: number;
    cementscreedThickness: number;
};

const Calculation = ({
    setCalculationValue,
    cementscreedLength,
    cementscreedWidth,
    cementscreedThickness
}: Props) => {
    const { t } = useGranite();

    return (
        <div className={"mt-4"}>
            <Row>
                <Col>
                    <h3 className="d-sm-block">
                        {t(
                            "calculator.cementscreedCalculator.cementscreedMeasurements"
                        )}
                    </h3>
                </Col>
            </Row>
            <Row>
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementscreedLength"}
                    dimension={"length"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    {...(cementscreedLength && {
                        value: cementscreedLength
                    })}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementscreedWidth"}
                    dimension={"width"}
                    unit={"m"}
                    setCalculationValue={setCalculationValue}
                    {...(cementscreedWidth && { value: cementscreedWidth })}
                />
                <CalculationField
                    sm={4}
                    md={3}
                    lg={2}
                    name={"cementscreedThickness"}
                    dimension={"thickness"}
                    unit={"cm"}
                    setCalculationValue={setCalculationValue}
                    {...(cementscreedThickness && {
                        value: cementscreedThickness
                    })}
                />
            </Row>
        </div>
    );
};

export default Calculation;
